<template>
<div class="electricity-block">
  <span class="title">
    <img src="/static/images/svolt/statisticsTitle.png" />
    <p class="name">{{electricityBlockData.name}}</p>
  </span>
  <div class="content">
    <div class="left">
      <div v-if="electricityBlockData.todayChargingCapacity" class="todayChargingCapacity">
        <p class="value">
          <span class="number">{{electricityBlockData.todayChargingCapacity}}</span>
          <span class="unit">{{electricityBlockData.todayChargingCapacityUnit}}</span>
        </p>
        <p class="explain">{{electricityBlockData.todayChargingCapacityName}}</p>
      </div>
      <div v-if="electricityBlockData.todayDischargeCapacity" class="todayDischargeCapacity">
        <p class="value">
          <span class="number">{{electricityBlockData.todayDischargeCapacity}}</span>
          <span class="unit">{{electricityBlockData.todayDischargeCapacityUnit}}</span>
        </p>
        <p class="explain">{{electricityBlockData.todayDischargeCapacityName}}</p>
      </div>
    </div>
    <div class="center">
      <img :src="'/static/images/svolt/'+ electricityBlockData.id + 'Icon.png'" alt="">
    </div>
    <div class="right">
      <div v-if="electricityBlockData.totalChargingCapacity" class="totalChargingCapacity">
        <p class="value">
          <span class="number">{{electricityBlockData.totalChargingCapacity}}</span>
          <span class="unit">{{electricityBlockData.totalChargingCapacityUnit}}</span>
        </p>
        <p class="explain">{{electricityBlockData.totalChargingCapacityName}}</p>
      </div>
      <div v-if="electricityBlockData.totalDischargeCapacity" class="totalDischargeCapacity">
        <p class="value">
          <span class="number">{{electricityBlockData.totalDischargeCapacity}}</span>
          <span class="unit">{{electricityBlockData.totalDischargeCapacityUnit}}</span>
        </p>
        <p class="explain">{{electricityBlockData.totalDischargeCapacityName}}</p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    blockData: {
      type: Object
    }
  },
  data() {
    return {
      electricityBlockData: {}
    }
  },
  watch: {
    blockData(val) {
      this.electricityBlockData = val;
    }
  },
  mounted() {
    this.electricityBlockData = this.blockData;
  },
  methods: {}
}
</script>

<style lang="scss">
.electricity-block {
  display: inline-block;
  height: 21vh;
  padding-left: 28px;
  text-align: center;

  .title {
    width: 100%;
    line-height: 25px;

    .name {
      color: #fff;
      margin-top: -30px;
    }

    img {
      width: 60%;
    }
  }

  .content {

    .todayChargingCapacity,
    .todayDischargeCapacity,
    .totalChargingCapacity,
    .totalDischargeCapacity {
      height: 60px;
      line-height: 15px;
      position: relative;
      padding-top: 25px;
      z-index: 99;
    }

    .value {
      width: 125px;
      padding-right: 30px;
    }

    .number {
      color: #19191A;
      font-size: 20px;
      font-family: DINBold;
      font-weight: bold;
    }

    .unit {
      font-size: 12px;
      font-weight: bold;
      margin-left: -2px;
    }

    .explain {
      color: #50515A;
      font-size: 12px;
      font-family: PingFang;
      font-weight: 600;
      width: 125px;
      padding-right: 30px;
    }

    .todayChargingCapacity {
      background: url("/static/images/svolt/chargingCapacity-l.png") no-repeat;
      background-size: 70%;
      background-position-x: 5px;
      background-position-y: 20px;
      height: 50%;
      text-align: right;
    }

    .todayDischargeCapacity {
      background: url("/static/images/svolt/dischargeCapacity-l.png") no-repeat;
      background-size: 70%;
      background-position-x: 5px;
      background-position-y: 20px;
      height: 50%;
      text-align: right;
    }

    .totalChargingCapacity {
      background: url("/static/images/svolt/chargingCapacity-r.png") no-repeat;
      background-size: 90%;
      background-position-y: 20px;
      height: 50%;
      margin-left: 40px;
      padding-left: 40px;
      text-align: left;
    }

    .totalDischargeCapacity {
      background: url("/static/images/svolt/dischargeCapacity-r.png") no-repeat;
      background-size: 90%;
      background-position-y: 20px;
      height: 50%;
      margin-left: 40px;
      padding-left: 40px;
      text-align: left;
    }

    .left {
      float: left;
      width: 50%;
      height: 15vh;
      text-align: right;

      .value {
        width: 120px;
        padding-right: 30px;
      }

      .explain {
        width: 120px;
        padding-right: 30px;
      }
    }

    .center {
      width: calc(100% - 35px);
      position: absolute;

      img {
        width: 100%;
        height: 150px;
        // margin-left: 5px;
        z-index: 11;
      }
    }

    .right {
      float: left;
      width: 50%;
      height: 15vh;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/svolt/components/electricity-block.vue